import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import FolderIcon from "@mui/icons-material/Folder";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import "./collapsible-menu.scss";

const CollapsibleMenu = ({
  isVisible = false,
  sidebarCollapse = false,
  onNewChatClick,
  onMouseEnter,
  onMouseLeave,
}) => {
  const [projectsExpanded, setProjectsExpanded] = useState(true);
  const [chatsExpanded, setChatsExpanded] = useState(true);

  return (
    <div
      className={classNames("collapsible-menu", {
        "collapsible-menu--visible": isVisible,
        "collapsible-menu--sidebar-collapsed": sidebarCollapse,
      })}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="collapsible-menu__section">
        <button
          className="collapsible-menu__new-chat-button"
          onClick={onNewChatClick}
          type="button"
        >
          <AddIcon className="collapsible-menu__new-chat-icon" />
          <span className="collapsible-menu__new-chat-text">New Chat</span>
        </button>
      </div>

      <div className="collapsible-menu__section">
        <div
          className="collapsible-menu__section-header"
          onClick={() => setProjectsExpanded(!projectsExpanded)}
          style={{ cursor: "pointer" }}
        >
          <FolderIcon
            className="collapsible-menu__section-icon"
            sx={{ color: "rgba(255, 255, 255, 0.7)" }}
          />
          <span className="collapsible-menu__section-title">Projects</span>
        </div>
        <div
          className={classNames("collapsible-menu__chats-list", {
            "collapsible-menu__chats-list--collapsed": !projectsExpanded,
          })}
        >
          <Link
            to="/ai-builder/conversations/chats"
            className="collapsible-menu__chat-item"
          >
            Run Funds Position
          </Link>
          <Link
            to="/ai-builder/conversations/chats"
            className="collapsible-menu__chat-item"
          >
            Email Template Builder
          </Link>
          <Link
            to="/ai-builder/conversations/chats"
            className="collapsible-menu__chat-item"
          >
            Linkedin Copy
          </Link>
        </div>
      </div>

      <div className="collapsible-menu__section">
        <div
          className="collapsible-menu__section-header"
          onClick={() => setChatsExpanded(!chatsExpanded)}
          style={{ cursor: "pointer" }}
        >
          <ChatBubbleIcon
            className="collapsible-menu__section-icon"
            sx={{ color: "rgba(255, 255, 255, 0.7)" }}
          />
          <span className="collapsible-menu__section-title">Chats</span>
        </div>
        <div
          className={classNames("collapsible-menu__chats-list", {
            "collapsible-menu__chats-list--collapsed": !chatsExpanded,
          })}
        >
          <Link
            to="/ai-builder/conversations/chats"
            className="collapsible-menu__chat-item"
          >
            Summary of Todays Work
          </Link>
          <Link
            to="/ai-builder/conversations/chats"
            className="collapsible-menu__chat-item"
          >
            What do I need to focus...
          </Link>
          <Link
            to="/ai-builder/conversations/chats"
            className="collapsible-menu__chat-item"
          >
            Spelling and grammar ch...
          </Link>
        </div>
      </div>
    </div>
  );
};

CollapsibleMenu.propTypes = {
  isVisible: PropTypes.bool,
  sidebarCollapse: PropTypes.bool,
  onNewChatClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

export default CollapsibleMenu;
